/**
 * User: hella
 * Date: 5/17/14
 * Time: 10:10 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * moved from .com/dibs/assets/js/global/core/commonjs/dibsConstants.js
 */

'use strict';

module.exports = {
    pageEventPrefix: 'page',
    // todo: use FinancialAmount model constants from bunsen (speak to rob if any questions)
    currency: {
        symbols: {
            pnd: '£',
            gbp: '£',
            eur: '€',
            usd: '$'
        },
        codes: {
            pnd: 'PND',
            gbp: 'PND',
            eur: 'EUR',
            usd: 'USD'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/dibsConstants.js
// module id = 455
// module chunks = 62